import { ServiceApi } from "./Api";
export class ServiceModalidade {
    
    getAll() {
        
        return ServiceApi.post("api/agenda/GetModalidades", {});
    }
}